<template>
  <div class="slide">
    <ul class="slide-wrapper">
      <li @click="changeBodyContent(0)">
        <div class="slide-item" :class="activeIndex===0 ? 'active' : ''">
          <span class="item-right">我的应用</span>
        </div>
      </li>
      <li @click="changeBodyContent(1)">
        <div class="slide-item" :class="activeIndex===1 ? 'active' : ''">
          <span class="item-right">API申请指南</span>
        </div>
      </li>
      <!-- <li @click="changeOpenStatus">
        <div class="slide-item" :class="activeIndex===2 ? 'active' : ''">
          <span class="item-right">API列表<img :class="openStatus?'':'transform'" src="../../assets/img/home_btn_arrow_right.png" alt=""></span>
        </div>
      </li>
      <ul class="item-ul" :class="openStatus?'':'hidden'">
        <li @click="changeApi(1)" :class="hash===1 ? 'active' : ''">影院列表</li>
        <li @click="changeApi(2)" :class="hash===2 ? 'active' : ''">热门影票</li>
        <li @click="changeApi(3)" :class="hash===3 ? 'active' : ''">创建订单</li>
        <li @click="changeApi(4)" :class="hash===4 ? 'active' : ''">订单查询</li>
        <li @click="changeApi(5)" :class="hash===5 ? 'active' : ''">提交订单</li>
        <li @click="changeApi(6)" :class="hash===6 ? 'active' : ''">取消订单</li>
        <li @click="changeApi(7)" :class="hash===7 ? 'active' : ''">获取账户信息</li>
      </ul> -->
      <li @click="changeBodyContent(2)">
        <div class="slide-item" :class="activeIndex===2 ? 'active' : ''">
          <span class="item-right">API列表</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SildeNav",
  data: function () {
    return {
      activeIndex: 0,
      hash: undefined,
      openStatus: true
    }
  },
  mounted: function () {
    this.changeBodyContent(0)
  },
  watch: {
    $route(to, from) {
      var activeIndex
      switch (to.path) {
        case '/pc/document/guide':
          activeIndex = 1
          break;
        case '/pc/document/user':
          activeIndex = 0
          break;
        case '/pc/document/contact':
          activeIndex = 2
          break;
        default:
          activeIndex = -1
          break;
      }
      if(activeIndex >= 0){
        this.changeBodyContent(activeIndex)
      }
    }
  },
  methods: {
    changeBodyContent: function (activeIndex) {
      this.activeIndex = activeIndex
      var url
      switch (activeIndex) {
        case 1:
          url = '/pc/document/guide'
          break;
        case 2:
          url = '/pc/document/contact'
          break;
        default:
          url = '/pc/document/user'
      }
      this.$router.push(url).catch(err => { err })
    },
    changeOpenStatus() {
      this.openStatus = this.openStatus ? false : true
    },
    changeApi(hash) {
      var url = '/pc/document/api/'+hash
      this.hash = hash
      this.$router.push(url).catch(err => { err })
    }
  }
}
</script>

<style scoped>
.slide {
  width: 4.4rem;
  background: #F9FAFC;
  height: 100%;
  padding-top: 20px;
  border-radius: 8px;
  border-right: 1px solid #f9fafc;
  box-shadow: 1px 1px 10px #eaeaea;
  -webkit-box-shadow: 1px 1px 10px #eaeaea;
}
.slide-wrapper {
  list-style: none;
}
.slide-wrapper li {
  width: 100%;
  height: 35px;
}
.slide-wrapper li .slide-item {
  padding: 0 0.5rem;
  height: 100%;
  cursor: pointer;
  color: #666666;
  font-size: 14px;
  font-weight: bold;
  width: 100%;
}
.slide-wrapper li .slide-item.active,.item-ul li.active {
  color: #FF6600;
}
.slide-wrapper li .slide-item .item-left {
  width: 0.4rem;
  float: left;
  margin-right: 0.5rem;
}
.item-right img{
  width: 20px;
  height: 20px;
  float: right;
  /* Rotate div */
  transform:rotate(90deg);
  -ms-transform:rotate(90deg); /* Internet Explorer */
  -moz-transform:rotate(90deg); /* Firefox */
  -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
  -o-transform:rotate(90deg); /* Opera */
}
.item-ul{
  padding-left: 0.85rem;
  line-height: 26px;
  color: #757576;
  font-weight: normal;
  width: 100%;
  overflow: hidden;
}
.item-ul li{
  cursor: pointer;
}
img.transform{
  transform:rotate(270deg);
  -ms-transform:rotate(270deg); 	/* IE 9 */
  -moz-transform:rotate(270deg); 	/* Firefox */
  -webkit-transform:rotate(270deg); /* Safari å’Œ Chrome */
  -o-transform:rotate(270deg); 	/* Opera */
}
.hidden{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/document/SildeNav.vue